import type { ReproduceSearchParams } from '~/services/ReproduceSearchService';

export const reproduceSearchQueryKeys = {
  all: ['reproduce-search'] as const,
  result: (params: ReproduceSearchParams) => [...reproduceSearchQueryKeys.all, 'result', params] as const,
  impressions: (params: ReproduceSearchParams) => [...reproduceSearchQueryKeys.all, 'impressions', params] as const,
};
